//
// Generated class BusinessReasonType
//

/// <reference path="BusinessReasonType_ManagedObject.ts" />

// Which deactivate/reactivate dropdown a reason type appears in
// (both pickers filter with "scope == 0 OR scope == <their scope>").
enum BusinessReasonTypeScope
{
    both       = 0,
    leave      = 1,
    reactivate = 2
}

class BusinessReasonType extends BusinessReasonType_ManagedObject
{

}
